module.exports = __webpack_public_path__ + "static/media/sponsor_pocari.9c3efe62.webp";